import React from 'react'
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useAddCrossDockingMutation } from "store/services/crossDockingApi";

import CrossDockingForm from "./CrossDockingComponents/CrossDockingForm";

import { useAppMeta } from "hooks";

const CrossDockingCreateScreen = () => {

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Cross Docking", path: "/app/crm/cross-docking/list" },
    { title: "New Cross Docking" }];

  const [createCrossDocking, { isLoading: creatingCrossDocking }] =
    useAddCrossDockingMutation();

  // methods
  const handleAddCrossDocking = async (data) => {

    try {
      const { _id } = await createCrossDocking(data).unwrap();
      toast.success("Cross Docking Created !");
      navigate(`/app/crm/cross-docking/${_id}/detail`)
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? "Could Not Created Cross Docking !"
      );
    }
  }
  useAppMeta("New Cross Docking");
  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingCrossDocking}>
      <BreadcrumbLayout.Paper>
        <CrossDockingForm isBusy={creatingCrossDocking} onSubmit={handleAddCrossDocking} />
      </BreadcrumbLayout.Paper>

    </BreadcrumbLayout>
  )
}

export default CrossDockingCreateScreen;